import React from 'react';
import PropTypes from 'prop-types';

import DatepickerComponent from 'core/gd-components/datetime/datepicker/datepicker';

export default class FormElementDatepicker extends React.Component {

    static propTypes = {
        inline: PropTypes.bool,     // display inline mode

        form: PropTypes.object,             // form manager
        name: PropTypes.string,             // name of the form field for date
        timeRangeName: PropTypes.string,    // name of the form field for time range (if needed)

        icon: PropTypes.object,
        preIcon: PropTypes.string,
        minDate: PropTypes.object, // moment object
        maxDate: PropTypes.object, // moment object
        className: PropTypes.string,
        placeholderText: PropTypes.string,
        markPastdue: PropTypes.bool,
        disabled: PropTypes.bool,
        showTailArrow: PropTypes.bool,

        timeRangeRequired: PropTypes.bool,
        humanizeValue: PropTypes.bool,
        valueFormat                 : PropTypes.string, // redefine date format
        timeRangeValueFormat: PropTypes.string,

        popoverAttachment: PropTypes.string,
        popoverTargetAttachment: PropTypes.string,

        btnDelete: PropTypes.bool,
        btnToday: PropTypes.bool,
        btnTomorrow: PropTypes.bool,
        btnSomeday: PropTypes.bool,
        btnNoValue: PropTypes.bool,
        btnNoValueLabel: PropTypes.string,
    };

    static defaultProps = {
        markPastdue: false,
        humanizeValue: true,
        popoverAttachment: 'top center',
        popoverTargetAttachment: 'bottom center',
    };

    constructor(props) {
        super(props);

        this.displayName = 'FormElementDatepicker';

        if (this.props.form) {
            this.props.form.registerFormComponent(this.props.name,this);
            if (this.props.timeRangeName) this.props.form.registerFormComponent(this.props.timeRangeName,this);
        }
    }

    onChange = (newDateValue, newTimeRangeValue) => {
        if (this.props.form) {
            this.props.form.onFormComponentValueChange(this.props.name,newDateValue);
            if (this.props.timeRangeName) this.props.form.onFormComponentValueChange(this.props.timeRangeName,newTimeRangeValue);
        }
        this.forceUpdate();
    }

    onSelectSomeday = (newValue) => {
        //this.props.form.onFormComponentValueChange(this.props.name,newValue);
    }

    onDeleteClick = () => {
        this.onChange(null);
    }

    render() {
        let dateValue, timeRangeValue;
        if (this.props.form) {
            dateValue = this.props.form.getValue(this.props.name);
            if (this.props.timeRangeName) timeRangeValue = this.props.form.getValue(this.props.timeRangeName);
        } else {
            if (!_.isNil(this.props.value)) dateValue = this.props.value;
            if (!_.isNil(this.props.timeRangeValue)) timeRangeValue = this.props.timeRangeValue;
        }

        return (
            <DatepickerComponent className={this.props.className}
                                 value={dateValue}
                                 // valueFormat={this.props.valueFormat ? this.props.valueFormat : this.props.inline ? "ddd, MMM D" : "YYYY-MM-DD"}
                                 valueFormat={this.props.valueFormat}
                                 timeRangeValue={timeRangeValue}
                                 timeRangeValueFormat={this.props.timeRangeValueFormat ? this.props.timeRangeValueFormat : "hh:mm a"}
                                 humanizeValue={this.props.humanizeValue}
                                 placeholderText={this.props.placeholderText}
                                 minDate={this.props.minDate}
                                 maxDate={this.props.maxDate}
                                 markPastdue={this.props.markPastdue}
                                 onSelect={this.onChange}
                                 onSelectSomeday={this.onSelectSomeday}
                                 skin={this.props.inline ? "inline" : "form"}
                                 preIcon={this.props.preIcon}
                                 showTailArrow={this.props.showTailArrow}
                                 popoverAttachment={this.props.popoverAttachment}
                                 popoverTargetAttachment={this.props.popoverTargetAttachment}
                                 showTimeSelector={!!this.props.timeRangeName}
                                 timeRangeRequired={this.props.timeRangeRequired}
                                 btnToday={this.props.btnToday}
                                 btnTomorrow={this.props.btnTomorrow}
                                 btnSomeday={this.props.btnSomeday}
                                 btnNoValue={this.props.btnNoValue}
                                 btnNoValueLabel={this.props.btnNoValueLabel}
                                 btnDelete={this.props.btnDelete}
                                 disabled={this.props.disabled}
                                 onTogglePopover={this.props.onTogglePopover}>
                {(this.props.inline || this.props.icon) ? this.props.icon : <div className=" i5-calendar icon"/>}
            </DatepickerComponent>
        );
    }
}